import { useUserContext } from '../auth/UserProvider'
import HelpUI from '../ui/views/help'
import Loader from '../ui/views/Loader'

const Help = () => {
  const { isLoading, webUserName } = useUserContext()

  if (isLoading) {
    return <Loader />
  }

  return <HelpUI user={webUserName} emailContact="integracion@cttexpress.com" />
}

export default Help
